/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
export { default as Axis } from './Axis';
export { default as Axes } from './Axes';
export { default as Grid } from './Grid';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/core/es/components/axes/index.js
// module id = 1385
// module chunks = 0